export const selectFrozenDraft = state => state.drafts.frozenDraft || null
